import React from "react";
import pick from "lodash/pick";
import size from "lodash/size";
import findKey from "lodash/findKey";

import identify from "~/identify";
import { connect, batch } from "~/redux/connect";
import { getAllResultStateInfos } from "~/stateGetter";
import {modelActionsCreator} from "~/actions/model_actions";
import { presentFilters, presentAppliedFilterValues } from "~/statePresenter";

import { Filter } from "~/ui/Fields/VariadicField/VariadicField";
import { Dropdown } from "~/native-ui";


class CreateFilter extends React.PureComponent {
    state = {
        selectedFilter: "",
    }

    filterType = "";
    constructor(props) {
        super(props);
        // this.state.selectedFilter = this.props.createFilterFor || this.props.filters[0]?.name || "";
    }

    fieldData = {
        field: {}
    }



    renderFilterOptions() {
        return null;
    }
    

    renderConstraint() {
        const source = this.props.filters
            .map(({ name, title }) => ({
                key: name,
                label: title
            }))

        
        const dropdownProps = {
            mt: "0",
            valueKey: "key",
            labelKey: "label",
            allowBlank: false,
            value: this.state.selectedFilter,
            onChange: this.onFieldChange,
            source,
        }

        return (
            <Dropdown { ...dropdownProps } />
        );
    }

    
    render() {
        return <Filter
            createFilter
            filterType="create"
            fieldData={this.fieldData}
            index={ this.props.appliedFiltersCount ? -1 : 0 }
            type="create"
            modelId={this.props.modelId}
            name={this.state.selectedFilter}
            onSubmitEditing={ this.applyChanges }
        />
    }
}

const mapStateToProps = (state, { modelId }) => ({
    ...pick(getAllResultStateInfos(state, modelId), "filterValues", "initialFilterValues", "filters"),
});


const mergeProps = (stateProps, dispatch, ownProps, ) => {
    let appliedFilters = presentAppliedFilterValues({...stateProps, }),
        filters = presentFilters({filters: stateProps.filters })
        filters = filters.filter(({ name, skipFieldValue }) => !(name in appliedFilters) || skipFieldValue );

    return {
        ...dispatch,
        ...ownProps,
        filters,
        appliedFiltersCount: size(appliedFilters),
        createFilterFor: findKey(stateProps.filterValues, ({ skipFieldValue }) => skipFieldValue),
    }
};

const CreateFilterRX = connect(mapStateToProps, null, mergeProps)(CreateFilter)

export { CreateFilterRX as CreateFilter }